module.exports = __webpack_public_path__ + "static/media/chef.2e8d89b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Chef/images/chef.png
// module id = 318
// module chunks = 0